import { TaskTimeLogModel } from "@jugl-web/rest-api/tasks/models/TaskTimeLog/TaskTimeLogModel";
import { cx, useAppVariant, useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { TimeTrackingHistoryProps } from "../../types";
import { HistoryListItem } from "../HistoryListItem";

interface HistoryListProps {
  timeLogs: TaskTimeLogModel[];
  onShowAll: () => void;
  onEditTimeLog?: TimeTrackingHistoryProps["onEditTimeLog"];
  onDeleteTimeLog?: TimeTrackingHistoryProps["onDeleteTimeLog"];
}

export const HistoryList: FC<HistoryListProps> = ({
  timeLogs,
  onShowAll,
  onEditTimeLog,
  onDeleteTimeLog,
}) => {
  const { t } = useTranslations();

  const { isMobile } = useAppVariant();

  return (
    <div className={cx("flex w-full flex-col", isMobile && "gap-3")}>
      {timeLogs.map((timeLog) => (
        <HistoryListItem
          key={timeLog.id}
          timeLog={timeLog}
          onEditTimeLog={onEditTimeLog}
          onDeleteTimeLog={onDeleteTimeLog}
        />
      ))}
      {timeLogs.length === 0 && (
        <span className="text-dark-500 font-secondary px-2 pt-2 text-xs tracking-[0.14px]">
          {t({
            id: "tasks-page.no-logs-yet",
            defaultMessage: "You don't have time logs for this task yet 👀",
          })}
        </span>
      )}
      <button
        type="button"
        onClick={onShowAll}
        className="jugl__focusable-outline text-primary hover:text-primary-800 font-secondary tracking=[0.14px] my-1 cursor-pointer self-start border-none bg-transparent px-2 px-0 text-sm font-medium underline transition-colors"
      >
        {t({
          id: "tasks-page.see-all-logs",
          defaultMessage: "See all logs",
        })}
      </button>
    </div>
  );
};
